import React from "react";
import "./battery.css"; // you can reuse service CSS
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function BatteryService() {
  return (
    <>
<Helmet>
  <title>
    Car Battery Check & Replacement Service in Palwal | AutoCare
  </title>

  <meta
    name="description"
    content="Need car battery check or replacement in Palwal? AutoCare offers professional battery testing, terminal cleaning and reliable battery replacement for all car brands."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/services/battery"
  />
</Helmet>

    <section className="servicePage">
      <div className="serviceContent">
        {/* Left side text */}
        <div className="textContent">
          <h1>Battery Check & Replacement Service</h1>

          <p>
            Ensure your car starts reliably with our <strong>Battery Check & Replacement</strong> service. 
            At <strong>AutoCare</strong>, we offer professional <span className="highlight">car repair</span> services. 
            Trusted <span className="highlight">Auto Care in Palwal</span>, we keep your vehicle powered and safe.
          </p>

          <h2>Why Battery Check & Replacement is Important?</h2>
          <p>
            A healthy car battery is crucial for engine start and electrical systems. 
            Regular inspections and timely replacement prevent breakdowns and save you from being stranded on the road.
          </p>

          <h2>Our Battery Service Includes:</h2>
          <ul>
            <li>Comprehensive battery health check</li>
            <li>Terminal cleaning and maintenance</li>
            <li>Voltage and charging system inspection</li>
            <li>Replacement with high-quality batteries if needed</li>
            <li>Post-service check of engine and electrical systems</li>
          </ul>

          <h2>Benefits of Choosing AutoCare</h2>
          <ul>
            <li>Expert technicians and reliable service</li>
            <li>Prevents unexpected breakdowns</li>
            <li>Improves battery lifespan and performance</li>
            <li>Trusted <span className="highlight">car repair service</span> in Palwal</li>
            <li>Peace of mind with professional maintenance</li>
          </ul>

          <h2>Book Your Battery Check & Replacement</h2>
          <p>
            Looking for a trusted <span className="highlight">car repair</span> service? 
            Schedule your <strong>Battery Check & Replacement</strong> with <strong>AutoCare</strong> today.
          </p>

          <button className="primaryBtn"> 
            <Link to="/contact">
              Book Battery Service
            </Link>
          </button>
        </div>

        {/* Right side image */}
        <div className="imageContent">
          <img src="/carServiceImages/carbattery.webp" alt="Battery Check & Replacement Service" />
        </div>
      </div>
    </section>
    </>
  );
}
